import { useDisclosure } from '@chakra-ui/react';
import React from 'react';

import { CalendarModal } from './CalendarModal';
import { DateAndVersionInput } from './DateAndVersionInput';
import { RDFV } from 'packages/dataPipeline/types/dataPipelineTypes';

/**
 * lets you choose a new version to run pipeline.
 */
export const DateAndVersionSelector = ({
  implementationId,
  selectedRDFV,
  isNewVersion,
  setSelectedRDFV,
}: {
  selectedRDFV: RDFV | null;
  // the selected version has no run yet
  isNewVersion: boolean;
  // null shows the selected date and version without a choice
  setSelectedRDFV: ((pipeline: RDFV | null) => void) | null;
  implementationId: string;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <DateAndVersionInput
        selectedRDFV={selectedRDFV}
        isNewVersion={isNewVersion}
        onClick={() => setSelectedRDFV && onOpen()}
      />
      {isOpen && setSelectedRDFV && (
        <CalendarModal
          selectedRDFV={selectedRDFV}
          setSelectedRDFV={setSelectedRDFV}
          onClose={onClose}
          implementationId={implementationId}
        />
      )}
    </>
  );
};
